import NotificationManager from "../utils/class/notifications";

const TIMEOUT = 60000;

export default function Redirection () {
    const redirection = document.querySelector('#delayed-redirection');
    if (!redirection) return;

    const { redirect = '/', timeout = TIMEOUT } = redirection.dataset;

    new NotificationManager().sendNotification('success', 'Redirection!', 'Please authorize to continue exploring projects and unlock all Pledge Panda features.');

    setTimeout(() => {
        window.location.href = redirect;
    }, timeout);
}
